import React, { Fragment, useCallback } from 'react';
import { objectEntries } from '~/web-frontend-core/base/lib';
import { TBody } from '~/web-frontend-components/line/outcomes/additional/tables/TBody';
import { THead } from '~/web-frontend-components/line/outcomes/additional/tables/THead';
import { FavoriteStar } from '~/web-frontend-components/std/UI';
/**
 * Компонент таблицы доп росписи
 */
export const Tables = (props) => {
    if (!props.data) {
        return null;
    }
    const columns = objectEntries(props.data && props.data.tables || {})
        .filter(([, table]) => table.isSelected && table.isVisible)
        .reduce((columns, table, index) => {
        const columnNumber = index % props.columnCount;
        columns[columnNumber] = columns[columnNumber].concat([table]);
        return columns;
    }, Array.from({ length: props.columnCount }).map(() => []));
    const getCoef = (betID) => props.data && props.data.coefs[betID] || {};
    const getColumnStyle = useCallback((columnWidths) => (i, row = []) => {
        if (row.length === columnWidths.length) {
            return ({ width: `${columnWidths[i]}%` });
        }
        /** В заголовках таблиц некоторые ячейки объединены, поэтому необходимо пересчитать пропорции */
        const proportions = row.map(({ cs }) => cs || 1);
        if (proportions.every((p) => p === 1)) {
            return {};
        }
        const width = Array.from(columnWidths);
        const headerWidth = proportions
            .map((v) => width
            .splice(0, v)
            .reduce((p, c) => p + c));
        return ({ width: `${headerWidth[i]}%` });
    }, []);
    return <Fragment>
      {columns.map((data, i) => <div key={`column_${i}`} className={`g-r-d-col g-r-d-col-${props.columnCount}`}>
            {data.map(([tableID, { rows, columnWidths, isFolded, isFavorite }]) => {
                const [header, ...content_rows] = rows;
                return <div className={`g-t-v-d`} key={`table_${tableID}`}>
                  {props.onFavorite &&
                        <span className='g-t-fav' onClick={() => { props.onFavorite && props.onFavorite(tableID, !isFavorite); }}>
                        <FavoriteStar isFavorite={isFavorite}/>
                     </span>}
                  <span className={`g-t-ar ${isFolded ? 'open' : ''}`} onClick={() => { props.onFold(tableID, isFolded); }}>
                     <span className='f-s-ico-arrow_buttom_1'></span>
                  </span>
                  <table className='g-t-v'>
                     <thead>
                        <THead getColumnStyle={getColumnStyle(columnWidths)} rows={header}/>
                     </thead>
                     {!isFolded &&
                        <tbody>
                           <TBody highlightChanges={props.highlightChanges} isCoefChoosen={props.isCoefChoosen} onCoefChoose={props.onCoefChoose} disabled={props.data !== null && props.data.isDisabled} getColumnStyle={getColumnStyle(columnWidths)} rows={content_rows} getCoef={getCoef}/>
                        </tbody>}
                  </table>
               </div>;
            })}
         </div>)}
   </Fragment>;
};



// WEBPACK FOOTER //
// ./src/web-frontend-components/line/outcomes/additional/Tables.jsx